import { Link } from "react-router-dom";
import { ApplyForJobTitle } from "../../../../constants";
import { ApplyForJobListData } from "../../../../data/Job";
import { routes } from "../../../../routers/routes";

const ApplyForJob = () => {
  return (
    <div className="detail-sidebar-box">
      <Link to={routes.Pages.Other.ContactUs1} className="btn-solid">
        {ApplyForJobTitle}
      </Link>
      <ul className="sidebar-list">
        {ApplyForJobListData.map((item, index) => (
          <li key={index}>
            {item.title}
            <span>{item.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ApplyForJob;
